import { dayKeyOf } from '../../logic/activity';

/** Whole local-day difference between two dates (now - then), floored. */
function dayDiff(then: Date, now: Date): number {
  const a = new Date(then.getFullYear(), then.getMonth(), then.getDate()).getTime();
  const b = new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime();
  return Math.round((b - a) / 86_400_000);
}

/**
 * Human "last knit" label for the resume card. "today" / "yesterday" /
 * "N days ago" for the last week; a localized date beyond that.
 */
export function relativeDayLabel(then: Date, now: Date): string {
  if (dayKeyOf(then) === dayKeyOf(now)) return 'today';
  const diff = dayDiff(then, now);
  if (diff === 1) return 'yesterday';
  if (diff > 1 && diff < 7) return `${diff} days ago`;
  return then.toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
}
